module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isEmptyTimeline) ? _c('timeline', {
    staticClass: "article-timeline no-article-swipe",
    attrs: {
      "timelineConfig": _vm.timelineConfig,
      "nid": _vm.nid,
      "isOverlay": false
    }
  }) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37b361f7","hasScoped":true,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/node/ArticleTimeline.vue
// module id = 1740
// module chunks = 19